var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#share_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#share_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F36",
    d: "M19.332 14.667a4.66 4.66 0 0 0-3.839 2.024l-6.509-2.939a4.57 4.57 0 0 0 .005-3.488l6.5-2.954a4.66 4.66 0 1 0-.827-2.643q.006.397.08.786l-6.91 3.14a4.668 4.668 0 1 0-.015 6.827l6.928 3.128a5 5 0 0 0-.079.785 4.667 4.667 0 1 0 4.666-4.666m0-12.667a2.667 2.667 0 1 1 .002 5.334A2.667 2.667 0 0 1 19.332 2M4.666 14.667a2.667 2.667 0 1 1-.002-5.334 2.667 2.667 0 0 1 .002 5.334M19.332 22a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "share_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "share_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgShare;